<template>
	<div>
		<SignUpDisableDialog :ShowModal="ShowModal" @okclicked="afterOkHandled"></SignUpDisableDialog>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Document Submission For Verification</h2>
			</div>
		</div>
		<!-- eo main header -->

		<div class="main-section mgt-40">
			<div class="container">
				<div class="ekycdoc">
					<div class="ekucdoc_inner">
						<div class="lft">
							<div class="lft-head">
								<img src="/static/img/ekyc/mobile.png">
								<h3>Online Document Submmission (e-KYC) </h3>
							</div>
							<div class="p-sec">For eKYC verification requirements, please download and install the eRemit Mobile .
							</div>
							<div class="p-sec">eRemit Mobile Application will prompt customers to scan the following ID documents for our Online
								Document Submission,
							</div>
							<div class="p-sec">
								<strong>For Malaysian: Original MyKad</strong>
								<strong>For Foreigner: Original Passport and Employment visa </strong>
							</div>
							<div class="p-sec">
								Pelase <a href="#"> Click here </a>for more information.
							</div>
							<div class="downalod-app">
								<span>Downlaod eRemit app now </span>
								<div class="app-down-icons">
									<a @click="onRedirectMobile('google')"><img src="/static/img/ekyc/googlePlay.png"></a>
									<a @click="onRedirectMobile('iphone')"><img src="/static/img/ekyc/AppStore.png"></a>
									<a ><img src="/static/img/ekyc/qr.png"></a>
								</div>
							</div>
						</div>
						<!--end lft-->
						<div class="rgt">
							<div class="rgt-head">
								<img src="/static/img/ekyc/houseicon.png">
								<h3>Original Document Submission (KYC)</h3>
							</div>
							<div class="p-sec">
								For KYC verification requirements. please provide the following documents for our face to face verification,
							</div>
							<div class="p-sec">
								<strong>For Malaysian: Original MyKad</strong>
								<strong>For Foreigner: Original Passport and Employment visa </strong>
							</div>
							<div class="p-sec">
								Please visit any of our nearest branch for identity verification process. Click here for the full list of
								Merchantrade branch locations. Our branches are open everyday (including Public Holiday) from 9am to 6pm.
							</div>
							<div class="p-sec">
								If you are in Kiang Valley area, we offer free pickup service and verification of your identification documents. We
								will arrange our Marketing Executive to visit your place of residence or office.
							</div>
							<div class="p-sec _email">
								Please send an email with the following details to <a href="mailto:customercare@eremit.com.my">
									customercare@eremit.com.my </a>
							</div>
							<div class="p-sec subject">
								<span> Subject <strong>EREMIT DOCUMENTS COLLECTION </strong></span>
								<ul>
									<li>Address of Residence/Office</li>
									<li>Mobile Contact Number</li>
									<li>Preferred Date & Time Of Visit</li>
								</ul>
							</div>
							<div class="nextwrap">
								<a @click="onSignUpButtonClick" class="next-btn">Next > </a>
							</div>
						</div>
						<!--end rgt-->
					</div>
				</div>
				<!-- <div class="main-card ekyc-doc">
					<div class="row">
						<div class="col-lg-6 ekyc-online-document">
							<div class="row">
								
								<div class="col-md-4 mob-img">
									<img  src="/static/img/icons/mobile-icon.png">
								</div>
								<div class="col-md-8">
									<h3>Online Document Sumission (eKYC)</h3>
								</div>
								
								<p class="m-t-lg m-b-lg">
									For eKYC verification requirements, please download and install the eRemit Mobile Application.
								</p>
								<p class="m-t-lg m-b-lg">
									eRemit Mobile Application will prompt customers to scan the following ID documents for our Online Document
									Submission,
								</p>


								<ul>
									<li>
										For Malaysian: <b>Original MyKad</b>
									</li>
									<li>
										For Foreigner: <b>Original Passport</b> and <b>Employment visa</b>
									</li>
								</ul>

								<p>Download eRemit app now</p>
								
								<div class="col-md-12 download-icon">
									<div class="col-md-4">
										<a @click="onRedirectMobile('iphone')"><img src="/static/img/icons/appstore.png" alt=""></a>
									</div>
									<div class="col-md-4">
										<a @click="onRedirectMobile('googleplay')"><img src="/static/img/icons/googleplay.png" alt=""></a>
									</div>
									<div class="col-md-4">
										<a href=""><img src="/static/img/icons/eremit-qr.png" alt=""></a>
									</div>
								</div>


							</div>
						</div>
						<div class="col-lg-6 ekyc-original-document">
							
								<div class="row">
									<p class="m-t-lg m-b-lg">
										For KYC verification requirements. please provide the following documents for our face to face verification,
									</p>
									<ul>
										<li>
											For Malaysian: <b>Original MyKad</b>
										</li>
										<li>
											For Foreigner: <b>Original Passport</b> and <b>Employment visa</b>
										</li>
									</ul>

									<p class="m-t-lg m-b-lg">Please visit any of our nearest branch for identity verification process. Click here
										for the full list of Merchantrade branch locations. Our branches are open everyday (including Public Holiday)
										from 9am to 6pm.
									</p>
									<p class="m-t-lg m-b-lg">
										If you are in Kiang Valley area, we offer free pickup service and verification of your identification
										documents. We will arrange our Marketing Executive to visit your place of residence or office.
									</p>
									<p class="m-t-lg m-b-lg">
										Please send an email with the following details to customercare@eremit.com.my
									</p>
									<p class="m-t-lg m-b-lg">
										Subject EREMIT DOCUMENTS COLLECTION
									</p>
									<ul>
										<li>Address of Residence/Office</li>
										<li>Mobile Contact Number</li>
										<li>Preferred Date & Time Of Visit</li>
									</ul>

									<div class="col-md-12">
										<a @click="onNextKYC">Next></a>
									</div>
									

								</div>
						</div>
					</div>

				</div> -->
				<!-- eo main card -->

			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>
	
</template>
<script>
	import CommonService from "../../services/common";
	import kendo from "@progress/kendo-ui";
	import UserDetailSection from '../../shared/UserDetailSection.vue'
	import SignUpDisableDialog from '../../shared/DisableButtonDialog'
	export default {
		name: "UpgradeToKYC",
		 components: { UserDetailSection, SignUpDisableDialog },
		beforeRouteEnter(to, from, next) {
			next();
		},
		created() {

		},
		mounted() {

		},
		data() {
			return {
				vModel: {
					Token: null,
				},
				ShowModal: false
			};
		},
		methods: {
			// downloadInvoice: function () {
			// 	var token = CommonService.getStorage('token');
			// 	var cvrForm = document.createElement("form");
			// 	document.body.appendChild(cvrForm);
			// 	cvrForm.setAttribute(
			// 		"action",
			// 		CommonService.getBaseUrl("/") + "customer/upgradetokyc"
			// 	);
			// 	cvrForm.setAttribute("method", "post");
			// 	cvrForm.setAttribute("target", "_blank");
			// 	var formContent = "";
			// 	formContent += "<input type='hidden' name='Token' value='" + token + "'/>";
			// 	cvrForm.innerHTML = formContent;
			// 	cvrForm.submit();
			// 	document.body.removeChild(cvrForm);
			// },
			onNextKYC(){
				kendo.confirm("Do you want to continue KYC?").then(function () {
					CommonService.setStorage('IsCompleteForm','true')
		  			window.Vue.$router.push('/dashboard');
				}, function () {
		  			CommonService.logOut();
				});
			},

			onRedirectMobile(item){
				console.log(navigator.userAgent)

				// if(item=='googleplay')
				// 	window.location ='https://play.google.com/store/apps/details?id=com.app.mtaeremit&hl=en';
				// else
				// 	window.location='https://itunes.apple.com/us/app/e-remit/id1060407677?mt=8';
				if(this.Android())
					window.location ='https://play.google.com/store/apps/details?id=com.app.mtaeremit&hl=en';
				else if(this.iOS())
					window.location='https://itunes.apple.com/us/app/e-remit/id1060407677?mt=8';
				else
					return false;
			},
			Android() {
				return navigator.userAgent.match(/Android/i);
			},
			
			iOS: function() {
				return navigator.userAgent.match(/iPhone|iPad|iPod/i);
			},
			onSignUpButtonClick(evt){				
				evt.preventDefault(); 
				this.ShowModal = true;				
				return false;
			},	
			afterOkHandled(value){
				this.ShowModal = value;
			}	
    
		}
	};
</script>

<style scoped>
	/* .main-card {
		padding: 0;		
	}

	.main-card.ekyc-doc{
		background: none;
	}
	.main-card .ekyc-online-document {
			background: #C71C2E;
			-webkit-box-shadow: 5px 5px 3px 0px rgba(170, 171, 173, 1);
			-moz-box-shadow: 5px 5px 3px 0px rgba(170, 171, 173, 1);
			box-shadow: 5px 5px 3px 0px rgb(102, 102, 102);
		}

	.ekyc-online-document .row,.ekyc-original-document .row {
		padding: 50px;
	}

	.ekyc-online-document .mob-img img{
		width: 60%
	}
	.ekyc-online-document h3{
		margin-top: 20px;
	}

	.ekyc-original-document .row {
		margin-top :10p;
	}
	.download-icon img{
		width:60%
	} */

	 body{
	 font-family: Montserrat,sans-serif;
    font-size: 16px;
    background: #fafbfd;
    color: #112338;
 }
 


	.ekycdoc {
	max-width: 1170px;
	margin: 0 auto;
}

.lft {
	background: #c71c2e;
	flex-basis: 50%;
	color: #fff;
	padding: 55px;
	margin-top: -10px;
	margin-bottom: -10px;
	box-shadow: 1px 1px 13px #686262;
	position: relative;
	z-index: 99;
}

.ekucdoc_inner {
	display: flex;
	justify-content: space-between;
}

.rgt {
	flex-basis: 50%;
	padding: 55px;
	background: #e7e8ea;
}

.lft-head img {
	height: 143px;
	width: auto;
}

.rgt-head img {
	height: 71px;
	width: auto;
}


.lft-head,
.rgt-head {
	display: flex;
	justify-content: space-between;
	margin-bottom: 34px;
	align-items: center;
}

.lft-head h3,
.rgt-head h3 {
	margin:0;
	font-size: 34px;
	margin-left: 7%;
}

.p-sec {
	margin-bottom: 20px;
}

.p-sec strong {
	display: block;
}

.p-sec a {
	color: #fff;
}

.downalod-app span {
	display: block;
	margin-bottom: 15px;
	position: absolute;
}

.app-down-icons a img {
	max-width: 100%;
}

.app-down-icons {
	display: flex;
	justify-content: flex-end;
	align-items: baseline;
}

.app-down-icons a {
	margin-right: 10px;
}

.downalod-app {
	position: relative;
	margin-top: 7em;
}
.p-sec._email a {
    color: #333;
}

.p-sec.subject strong {
    display: inline-block;
}

.nextwrap .next-btn {
   text-decoration: none;
    font-weight: bold;
    color: #981b1f; 
}

@media (max-width:768px){
 .ekucdoc_inner {
 	display:block;
 }
 
}


</style>